import React from 'react';
import {ClickAwayListener, Tooltip, IconButton, useMediaQuery} from "@mui/material";
import PaySystemList from './PaySystemList';
import { styled, useTheme } from "@mui/material/styles";
import PSIcon from '../../components/PSIcon';

const MyTooltip = styled(Tooltip)(({ theme }) => ({
  // background: 'red',
  "&.MuiTooltip-tooltip": {
    maxWidth: 880,
    minWidth: 880,
    padding: '8px 8px',
    margin: '0 !important',
    position: 'relative',
    [theme.breakpoints.down('lg')]: {
      minWidth: '100%',
    },
    [theme.breakpoints.only('xs')]: {
      borderRadius: '32px'
    }
  }
}))

const ArrowButton = styled(IconButton)(() => ({
  position: 'relative',
  padding: '5px 25px 5px 5px',
  margin: '0 18px 0 0',
  "&::after": {
    content: "''",
    width: '12px',
    height: '6px',
    position: 'absolute',
    top: '50%',
    right: '0px',
    transform: 'translate(0, -50%)',
    background: 'url("/images/arrow-bottom.svg") center no-repeat',
    backgroundSize: 'contain',
    transition: 'transform 0.2s',
  },
  "&.active::after": {
    transform: 'translate(0, -50%) rotate(180deg)',
  }
}))

const ChoosePsDesctop = ({title, setOpenDialog, openDialog, paySystems, system, setSystem, currency, setCurrency}) => {
  const theme = useTheme();
  let isXS = useMediaQuery(theme.breakpoints.only('xs'));
  let isSM = useMediaQuery(theme.breakpoints.only('sm'));

  return (
    <ClickAwayListener onClickAway={() => setOpenDialog(false)}>
      <div>
        <Tooltip
          classes={{
            tooltip: 'systems-list',
          }}
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          PopperProps={{
            disablePortal: true,
            modifiers: [
              {
                name: "offset",
                options: {
                  offset: [0, 25],
                },
              },
              {
                name: 'flip',
                enabled: false
              }
            ],
          }}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          placement="bottom"
          title={
            <PaySystemList
              title={title}
              list={paySystems}
              onClose={() => setOpenDialog(false)}
              activeSystem={system}
              setSystem={setSystem}
              setCurrency={setCurrency}
              grid={isSM ? 4 : isXS ? 2 : 5}
            />
          }
        >
          <ArrowButton
            onClick={() => setOpenDialog(!openDialog)}
            className={openDialog && 'active'}
          >
            <PSIcon
              name={system.className}
              network={currency.network}
              height={40}
              width={40}
              margin={0}
            />
          </ArrowButton>
        </Tooltip>
      </div>
    </ClickAwayListener>
  )
}

export default ChoosePsDesctop